import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="fLists">
        <ul className="fList">
          <li className="fListItem">About</li>
          <li className="fListItem">FAQ</li>
          <li className="fListItem">Contact</li>
        </ul>
      </div>
      <div className="fText">Copyright 2024</div>
    </div>
  );
};

export default Footer;
